const _ = require('lodash');

class BaseObject {
    static methods = ['values', 'keys', 'at'];
    locale = "en";
    #raw;
    constructor(content, locale) {
        Object.assign(this, content)
        this.locale = locale;
        this.#raw = content;
        BaseObject.methods.map(method => {
            BaseObject.prototype[method] = function () {
                return _[method].apply(_, [this].concat(Array.from(arguments)))
            };
        })
    }
    toJson() {
        let tmpItem = {};
        Object.keys(this.#raw).map(key => {

            if (typeof this.#raw[key] === 'string'){
                tmpItem[key] = this.#raw[key];
            } else {
                tmpItem[key] = this.#raw[key]?.[this.locale]
            }

            if (tmpItem[key] === undefined) tmpItem[key] = null;
        })
        return tmpItem;
    }
}

module.exports = BaseObject;